module.exports = __webpack_public_path__ + "img/img_document_ko.b6e9aba6.svg";